module.exports = __webpack_public_path__ + "front/img/27_1.b7ba53a3.png";